export default __webpack_public_path__ + "static/media/invoice.aa84e165.svg";